import { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    useRecordContext,
    SelectInput,
} from 'react-admin';
import {
    Grid,
    LinearProgress
} from '@mui/material';
import { useGetCountries } from "../global-hooks/default-system-hooks";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";


const EditContactTitle: () => JSX.Element = (): JSX.Element => {
    const record: any = useRecordContext();
    if (!record) return null;
    return <span>{ "Person - " + record.name }</span>
}

export const AdminPeopleEdit: () => JSX.Element = (): JSX.Element => {
    const { loadedCountries, loading } = useGetCountries();
    return (
        <Edit title={ <EditContactTitle /> } >
            <SimpleForm>
                <Grid container spacing={ 2 }>
                    <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                        <TextInput name="name" source="name" validate={[required()]} />
                        <TextInput name="email" source="email" validate={[required()]} />
                    </Grid>
                    <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                        { (loading) &&
                            <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                        }
                        { (!loading) &&
                            <SelectInput
                                source="country"
                                choices={ loadedCountries }
                                optionValue="id"
                            />
                        }
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}